module.exports = __webpack_public_path__ + "img/ringba-phone-number-button.b7a8cb78.svg";